module.exports = __webpack_public_path__ + "static/netscape-26481cbe382a853b9a4f07f1becccb56.png";